import {
    Checkbox,
    FlexBox,
    ResponsiveImage,
    SelectionSetInput,
    SelectionSetLabel,
    Typography,
    tokensRaw,
} from '@vp/swan';

type WorkEntityItemProps = {
    id: string;
    selectedValue: boolean;
    onChange: () => void;
    title: string;
    editedAt: string;
    previewUrl: string;
    disabled?: boolean;
};

export function WorkEntityItem({
    id,
    selectedValue,
    onChange,
    title,
    editedAt,
    previewUrl,
    disabled,
}: WorkEntityItemProps) {
    return (
        <SelectionSetInput value={id} onChange={onChange} disabled={disabled}>
            <SelectionSetLabel>
                <FlexBox alignItems={'center'} justifyContent={'space-between'}>
                    <FlexBox alignItems={'center'} gap={4}>
                        <ResponsiveImage
                            key={title}
                            style={{
                                height: '48px',
                                width: '48px',
                                borderRadius: tokensRaw.SwanSemBorderRadiusSubtle,
                            }}
                            src={previewUrl}
                            alt={''}
                        />
                        <div>
                            <Typography fontSkin={'title-item'}>{title}</Typography>
                            <Typography fontSkin={'body-small'} textColor={'subtle'}>
                                {editedAt}
                            </Typography>
                        </div>
                    </FlexBox>
                    <Checkbox
                        name={`${title} checkbox`}
                        checked={selectedValue}
                        onChange={onChange}
                        value={id}
                        aria-hidden={true}
                        disabled={disabled}
                        tabIndex={-1}
                    />
                </FlexBox>
            </SelectionSetLabel>
        </SelectionSetInput>
    );
}
